export default __webpack_public_path__ + "162d0bf5cda1bfb7420ec9ad02d0e498.svg";